import React from "react";
import * as Style from "./style";

const Spacer = ({ mobile, desktop }) => (
  <Style.Spacer mobile={mobile} desktop={desktop} />
);

export default Spacer;
